import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Option } from '@euler/model';
import { OrderReturnType } from '@euler/model/enum';
import { memo } from 'react';
import { Path, Svg } from 'react-native-svg';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { IconWrapper } from '../components/IconWrapper';
import InlineRadios from '../components/InlineRadios';
import { Row } from '../components/Row';
import { RowErrorText } from '../components/RowErrorText';

const kOptions: Option<OrderReturnType>[] = [
  { value: OrderReturnType.OnSite, text: '在厂等待' },
  {
    value: OrderReturnType.Deliver,
    text: '安排送车',
  },
];

export const ReturnTypeRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor } = theme;

    return (
      <Row
        errorProp="returnType"
        note={<RowErrorText error={form.returnType.error} />}
        required={required}
        title="取车方式"
        icon={
          <IconWrapper>
            <RowIcon color={iconColor} />
          </IconWrapper>
        }
        detail={
          <InlineRadios
            options={kOptions}
            value={form.returnType.value}
            disabled={props.disabled}
            onChange={form.returnType.update}
          />
        }
        {...props}
      />
    );
  },
);

const RowIcon = memo(({ width, height, color, style, ...props }: IconProps) => {
  const { rpx } = useResponsiveContext();
  return (
    <Svg
      viewBox="0 0 1024 1024"
      width={width ?? rpx(22)}
      height={height ?? rpx(22)}
      style={style}
      fill="none"
      {...props}
    >
      <Path
        d="M509.074 784.471c-196.284 0-357.413-164.678-357.413-365.29 0-200.61 161.129-365.285 357.413-365.285 196.282 0 357.404 164.675 357.404 365.284 0 200.613-158.195 365.291-357.404 365.291M96 419.181C96 652.727 277.636 814.41 512 1024c234.37-209.59 416-368.28 416-604.82C928 185.64 743.437 0 512 0S96 185.64 96 419.18zM630.737 224c8.615 0.096 39.951 36.14 69.394 74.519 26.13 1.291 50.838 4.323 61.536 5.633 10.32 1.264 14.958 9.108 21.112 21.533 6.248 12.426 4.828 16.004-8.426 21.533-13.348 5.539-25.372 8.61-25.372 8.61s15.716 30.495 23.29 43.103c4.354 7.299 4.07 14.683 4.07 38.76 0 18.051 0.095 121.22-0.284 137.692-0.38 14.903-3.882 21.388-17.419 21.532-17.136 0.191-66.744 0-76.305 0-12.307 0-19.124-8.16-19.124-17.219v-30.514H350.511v30.514c0 9.06-4.638 17.219-16.945 17.219-9.562 0-51.88 0.182-68.92 0-13.633-0.153-16.947-6.639-17.326-21.542-0.379-16.473-0.19-130.574-0.095-153.81 0.095-14.75 0.569-14.845 4.735-22.68 7.005-12.943 22.625-43.132 22.625-43.132s-11.928-3.166-25.277-8.705c-13.254-5.52-14.58-9.27-8.426-21.696 6.154-12.416 10.793-20.595 21.112-21.858 10.697-1.31 35.312-3.673 61.441-4.974C352.783 260.14 384.12 224.096 392.64 224h238.097zM407.692 472.674V448.78c0.095-3.569-4.165-12.81-25.845-15.927-21.112-3.052-86.34-8.658-86.34-7.969-0.379 9.183-8.804 41.717 17.23 43.811 20.45 1.646 94.955 3.98 94.955 3.98z m312.604-3.98c26.129-2.123 17.609-34.637 17.325-43.81-0.095-0.69-65.134 4.916-86.34 7.968-21.68 3.118-25.846 12.359-25.846 15.927 0.095 3.577 0 19.304 0 23.895 0 0 74.412-2.334 94.86-3.98z m-208.75-111.02c59.833-0.02 146.646-0.058 170.124 0.028 7.858 0.029-1.514-27.482-25.182-56.572-29.443-36.274-37.395-38.474-42.413-38.512-7.573-0.067-39.573-0.077-67.973-0.067v0.048c-9.468 0-16.095-0.02-33.041-0.029-17.04 0.01-23.762 0.028-33.23 0.028v-0.047c-37.868-0.01-61.536 0-69.11 0.067-4.922 0.038-14.294 0.928-43.737 38.511-19.976 25.398-32.946 56.602-25.183 56.573 23.479-0.086 110.103-0.048 169.745-0.028z"
        fill={color}
      />
    </Svg>
  );
});
